"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _NotificationsActive = _interopRequireDefault(require("@material-ui/icons/NotificationsActive"));
var _checkIsTouch = _interopRequireDefault(require("../../utils/checkIsTouch"));
var _requestNotificationPermission = _interopRequireDefault(require("../../utils/push-notifications/requestNotificationPermission"));
var _subscribeToPushManager = _interopRequireDefault(require("../../utils/push-notifications/subscribeToPushManager"));
var _PushNotificationsBanner = _interopRequireDefault(require("./PushNotificationsBanner.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PushNotificationsBanner = () => {
  const [show, setShow] = (0, _react.useState)(false);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = (0, _PushNotificationsBanner.default)();
  const isTouch = (0, _checkIsTouch.default)();
  (0, _react.useEffect)(() => {
    if (typeof Notification === "undefined") return;
    const currentPermission = Notification.permission;
    const wasActive = localStorage.getItem("push-notifications-banner");
    if (!wasActive && currentPermission === "default") {
      setShow(true);
    }
  }, []);
  const handleConfirm = async () => {
    setShow(false);
    if (typeof Notification !== "undefined") {
      const permissionResult = await (0, _requestNotificationPermission.default)();
      if (permissionResult === "granted") {
        await (0, _subscribeToPushManager.default)({
          lang: i18n.language
        });
      }
    }
    localStorage.setItem("push-notifications-banner", "true");
  };
  const handleDecline = () => {
    setShow(false);
    localStorage.setItem("push-notifications-banner", "true");
  };
  if (isTouch || typeof Notification === "undefined" || !show) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.icon
  }, /*#__PURE__*/_react.default.createElement(_NotificationsActive.default, {
    color: "primary",
    fontSize: "medium"
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "p",
    variant: "h3"
  }, t("site.pushNotificationsBanner.headline")), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.text,
    component: "p",
    variant: "body2"
  }, t("site.pushNotificationsBanner.text")), /*#__PURE__*/_react.default.createElement("div", {
    className: css.buttons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    onClick: handleDecline
  }, t("site.pushNotificationsBanner.buttons.decline")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    size: "small",
    variant: "contained",
    onClick: handleConfirm
  }, t("site.pushNotificationsBanner.buttons.confirm")))));
};
var _default = exports.default = PushNotificationsBanner;